<sd-modal>
  <ng-container *ngIf="{ isTablet: isTablet$ | async } as obs">
    <div class="wrapper">
      <sd-pickup-shop-list-desktop
        *ngIf="!obs.isTablet"
        [shopList]="shops$ | async"
        (setShopId)="onSetShop($event)"
      ></sd-pickup-shop-list-desktop>

      <sd-pickup-shop-list-mobile
        *ngIf="obs.isTablet"
        [shopList]="shops$ | async"
        (setShopId)="onSetShop($event)"
      ></sd-pickup-shop-list-mobile>
    </div>
  </ng-container>
</sd-modal>
